
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/schools-cbt-solution",
      function () {
        return require("private-next-pages/home/schools-cbt-solution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/schools-cbt-solution"])
      });
    }
  